import { useTranslation } from 'react-i18next';

import Button from '../../../../../components/buttons/Button';
import type { GeneralWidgetProps } from '../../../types';

import styles from './GeneralWideWidget.module.scss';

export function GeneralWideWidget(props: GeneralWidgetProps) {
  const { widgetImageUrl, timer } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <img alt="" className={styles.img} src={widgetImageUrl} />
      <div className={styles.wrapper}>
        {timer}
        <div className={styles.btnWrapper}>
          <Button className={styles.btn}>{t('common.view')}</Button>
        </div>
      </div>
    </div>
  );
}
